import Paper from "@material-ui/core/es/Paper/Paper";
import React from "react";

import ActionBar from "../components/ActionBar";
import FormView from "../components/FormView";
import Loader from "../components/Loader";
import * as API from "../util/api";
import * as Util from "../util/util";
import * as Variant from "../util/variant";
import VLComponent from "./VLComponent";

class EditLevelsScreen extends VLComponent {
  constructor() {
    super();
    this.state = { loaded: false, groups: [], sensor_name: "", isV5: false };
  }

  componentDidMount() {
    Util.getLocation(pos => {
      this.setState({ lat: pos.coords.latitude, lng: pos.coords.longitude });
    });

    API.POST("systems/list", { sensor_id: this.props.id }, result => {
      Util.handleLogout(result);
      if (!result.success) return;

      const sensor = (result.result.sensors || [])[0];
      if (!sensor) return;

      const isV5 = !!sensor.idv5_camera;

      // V1 existing behaviour
      sensor.mAOD_en = sensor.mAOD > 0;
      this.setState({ ...sensor, isV5 });

      const groups = (result.result.groups || []).filter(a => a != null && a !== "null");
      this.setState({ groups });

      if (!isV5) {
        // V1 logic: hi-res sensor special case
        if (sensor.outstation_type === 3) {
          this.setState({ hiRes: true });
          sensor.hi_res_sensor.mAOD_en = sensor.hi_res_sensor.mAOD > 0;
          this.setState(sensor.hi_res_sensor);
        } else if (sensor.variant !== Variant.GAUGE) {
          this.basicAlert("This isn't a sensor", Util.goBack);
          return;
        }

        this.setState({ loaded: true });
        return;
      }

      // V5: we edit user_* settings (no hi_res_sensor object etc)
      // Keep UI stable: if fields missing, they just show empty.
      this.setState({
        loaded: true,
        // Provide safe defaults so the form doesn't render "undefined"
        user_water_level_sensor_high_alarm_point: sensor.user_water_level_sensor_high_alarm_point ?? "",
        user_water_level_sensor_rapid_alarm_point: sensor.user_water_level_sensor_rapid_alarm_point ?? "",
        user_water_level_cal_offset: sensor.user_water_level_cal_offset ?? "",
        user_rainfall_alarm_point: sensor.user_rainfall_alarm_point ?? "",
        user_normal_image_update_rate_time: sensor.user_normal_image_update_rate_time ?? "",
        user_camera_res: sensor.user_camera_res ?? "",
        user_enhanced_image_update_rate_time: sensor.user_enhanced_image_update_rate_time ?? "",
        user_enhanced_mode_run_time: sensor.user_enhanced_mode_run_time ?? "",
        running_system_default_settings: sensor.running_system_default_settings ?? 0
      });
    });

    // V1 needs groups/list for the "Auto Image Camera" dropdown
    API.POST("groups/list", {}, result => {
      let cameras = [{ name: "None", systemID: -1 }].concat(result.result.systems || []);
      this.setState({ cameras });
    });
  }

  render() {
    return (
      <div>
        <ActionBar title={"Edit Levels - " + (this.state.sensor_name || "")} />
        {this.renderTextAlert()}
        <div
          id="content"
          style={{
            display: this.state.loaded ? "flex" : "none",
            maxHeight: "calc(100vh - 70px)",
            padding: 24,
            overflowY: "auto",
            justifyContent: "center"
          }}
        >
          <Paper
            style={{
              padding: 16,
              borderRadius: 8,
              width: "25cm",
              maxWidth: "90vw",
              maxHeight: "calc(100vh - 120px)",
              overflowY: "auto"
            }}
          >
            <FormView questionWidth={216} items={this.getItems()} changeEvent={this.handleInputChange} />
          </Paper>
        </div>
        <Loader loaded={this.state.loaded} />
      </div>
    );
  }

  getItems = () => {
    if (!this.state.loaded) return [];

    const isV5 = !!this.state.isV5;

    if (isV5) {
      return [
        { type: "title", text: "V5 System Settings" },

        { type: "title", text: "Water Level" },
        { id: "user_water_level_sensor_high_alarm_point", name: "High Alarm Point (mm)", value: this.state.user_water_level_sensor_high_alarm_point, type: "text" },
        { id: "user_water_level_sensor_rapid_alarm_point", name: "Rapid Alarm Point (mm)", value: this.state.user_water_level_sensor_rapid_alarm_point, type: "text" },
        { id: "user_water_level_cal_offset", name: "Calibration Offset (mm)", value: this.state.user_water_level_cal_offset, type: "text" },

        { type: "title", text: "Rainfall" },
        { id: "user_rainfall_alarm_point", name: "Rainfall Alarm Point (mm)", value: this.state.user_rainfall_alarm_point, type: "text" },

        { type: "title", text: "Image Update / Performance" },
        { id: "user_normal_image_update_rate_time", name: "Normal Update (seconds)", value: this.state.user_normal_image_update_rate_time, type: "text" },
        { id: "user_enhanced_image_update_rate_time", name: "Enhanced Update (seconds)", value: this.state.user_enhanced_image_update_rate_time, type: "text" },
        { id: "user_enhanced_mode_run_time", name: "Enhanced Run Time (seconds)", value: this.state.user_enhanced_mode_run_time, type: "text" },
        { id: "user_camera_res", name: "Camera Resolution (index)", value: this.state.user_camera_res, type: "text" },

        { type: "title", text: "Defaults" },
        { id: "running_system_default_settings", name: "Running Default Settings", value: !!this.state.running_system_default_settings, type: "bool" },

        { type: "button", text: "Save", onClick: this.save }
      ];
    }

    // -------------------------
    // V1 (UNCHANGED UI)
    // -------------------------
    return [
      { type: "title", text: "Sensor Levels" },
      { id: "fido_alarms_en", name: "Level Alarms", value: !!this.state.fido_alarms_en, type: "bool" },
      ...(this.state.fido_alarms_en
        ? [
            { id: "act_con_level", name: Util.actConLevelName() + " Level (cm)", value: this.state.act_con_level, type: "text" },
            { id: "alert_level", name: Util.alertLevelName() + " Level (cm)", value: this.state.alert_level, type: "text" },
            { id: "warning_level", name: Util.warningLevelName() + " Level (cm)", value: this.state.warning_level, type: "text" }
          ]
        : []),
      { id: "under_range", name: "Under Range Level (cm)", value: this.state.under_range, type: "text" },
      { id: "mAOD_en", name: "mAOD Level", value: this.state.mAOD_en, type: "bool" },
      ...(this.state.mAOD_en ? [{ id: "mAOD", name: "mAOD Level (cm)", value: this.state.mAOD, type: "text" }] : []),
      { id: "smartphone_warning_en", name: "Smartphone Warning", value: !!this.state.smartphone_warning_en, type: "bool" },
      ...(this.state.smartphone_warning_en ? [{ id: "smartphone_warning", name: "Smartphone Level (cm)", value: this.state.smartphone_warning, type: "text" }] : []),
      { id: "auto_image_en", name: "Auto Image", value: !!this.state.auto_image_en, type: "bool" },
      ...(this.state.auto_image_en
        ? [
            { id: "auto_image_level", name: "Auto Image Level (cm)", value: this.state.auto_image_level, type: "text" },
            {
              id: "auto_image_camera_id",
              name: "Auto Image Camera",
              value: this.state.auto_image_camera_id,
              type: "dropdown2",
              options: (this.state.cameras || []).map(c => ({ id: c.systemID, label: c.name }))
            }
          ]
        : []),
      { type: "button", text: "Save", onClick: this.save }
    ];
  };

  save = () => {
    const isV5 = !!this.state.isV5;

    if (isV5) {
      // V5 payload: user_* + running_system_default_settings
      let data = this.filterState([
        "sensor_id",
        "user_water_level_sensor_high_alarm_point",
        "user_water_level_sensor_rapid_alarm_point",
        "user_water_level_cal_offset",
        "user_rainfall_alarm_point",
        "user_normal_image_update_rate_time",
        "user_camera_res",
        "user_enhanced_image_update_rate_time",
        "user_enhanced_mode_run_time",
        "running_system_default_settings"
      ]);

      data.running_system_default_settings = data.running_system_default_settings ? 1 : 0;

      API.POST("systems/setLevelsV5", data, result => {
        if (result.success) {
          this.basicAlert("Your changes have been saved", Util.goBack);
        } else {
          this.basicAlert(result.error);
        }
      });

      return;
    }

    // -------------------------
    // V1 save (UNCHANGED)
    // -------------------------
    let data = this.filterState([
      "sensor_id",
      "warning_level",
      "act_con_level",
      "alert_level",
      "under_range",
      "smartphone_warning_en",
      "smartphone_warning",
      "auto_image_en",
      "auto_image_camera_id",
      "auto_image_level",
      "fido_alarms_en",
      "mAOD",
      "mAOD_en"
    ]);

    data.smartphone_warning_en = data.smartphone_warning_en ? 1 : 0;
    data.auto_image_en = data.auto_image_en ? 1 : 0;
    data.fido_alarms_en = data.fido_alarms_en ? 1 : 0;
    if (!data.mAOD_en) {
      data.mAOD = 0;
    }

    const doSave = () => {
      API.POST("systems/setLevels", data, result => {
        if (result.success) {
          this.basicAlert("Your changes have been saved", Util.goBack);
        } else {
          this.basicAlert(result.error);
        }
      });
    };

    const levels = [
      { name: Util.warningLevelName() + " Level", level: data.warning_level, enabled: data.fido_alarms_en === 1 },
      { name: Util.actConLevelName() + " Level", level: data.act_con_level, enabled: data.fido_alarms_en === 1 },
      { name: Util.alertLevelName() + " Level", level: data.alert_level, enabled: data.fido_alarms_en === 1 },
      { name: "Smartphone Level", level: data.smartphone_warning, enabled: data.smartphone_warning_en === 1 }
    ];
    const badAlarms = levels.filter(e => e.level <= 0).filter(e => e.enabled);

    if (badAlarms.length > 0) {
      const levelsText = badAlarms.map(e => (
        <>
          <br />
          {e.name}
        </>
      ));
      const text = (
        <>
          The following levels are set to 0 and will not trigger alarms:
          <br />
          {levelsText}
        </>
      );
      this.showTextAlert("Warning", text, "Save Anyway", "Cancel", doSave);
    } else {
      doSave();
    }
  };
}

export default EditLevelsScreen;
